import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { useAuth } from "../../Common/Configurations/AuthContext";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";

const ChatModal = ({ show, onHide, phoneNumber }) => {
  const { user } = useAuth();
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");

  const getComments = async (phoneNumber) => {
    if (!phoneNumber) return;
    setIsLoading(true);
    try {
      const response = await apiService.getById(
        `${config.GETUSERCHAT}`,
        `${phoneNumber}`
      );
      console.log(response);
      setComments(response);
    } catch (err) {
      console.error("Error fetching comments:", err);
      setComments([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (show && phoneNumber) {
      getComments(phoneNumber);
    } else {
      setComments([]);
    }
  }, [show, phoneNumber]);
  const formatTimestamp = (timestamp) => {
    if (!timestamp) return ""; // Handle cases where timestamp might be null

    const date = moment.utc(timestamp); // Use Moment's flexible parser

    if (!date.isValid()) {
      return "Invalid date"; // Show error if parsing still fails
    }

    // Format to show only hours and minutes (e.g., "06:39 PM")
    return date.local().format("DD MMM YYYY, hh:mm A");
  };


  return (
    <Modal show={show} onHide={onHide} size="md" centered>
      <Modal.Header closeButton className="bg-primary text-white">
        <Modal.Title className="text-white">
          <i className="ri-chat-3-line me-2"></i>
          Whats App Chat Discussion
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: "0" }}>
        {/* Comments History Section */}
        <div
          className="p-3"
          style={{
            backgroundColor: "#f8f9fe",
            borderBottom: "1px solid #e9ecef",
            maxHeight: "300px",
            overflowY: "auto",
          }}
        >
          {isLoading ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : comments.length > 0 ? (
            comments.map((comment) => (
              <div className="mb-3" key={comment.chatMessageLogId}>
                <div className="card shadow-sm">
                  <div className="card-body p-2">
                    <p className="mb-1 text-dark">{comment.message}</p>
                    <p className="mb-1 text-dark">sent by : {comment.direction==="Outgoing"?"User":"Robot"}</p>
                    <small className="text-muted d-block text-end">
                      {formatTimestamp(comment.timestamp)}
                    </small>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-4">
              <i className="ri-chat-off-line fs-3 text-muted"></i>
              <p className="text-muted mt-2">
                No comments found. Start the conversation!
              </p>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ChatModal;
